module.exports = __webpack_public_path__ + "static/img/logo@2x.5ae35ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/logo@2x.png
// module id = 6ty8
// module chunks = 18